<template>
  <div>
    <ul id="nav">
      <li><a href="javascript:;" @click="linkTo(1)">活动介绍</a></li>
      <li class="current"><a href="javascript:;"><i></i>参赛证</a></li>
      <li><a href="javascript:;" @click="linkTo(3)">比赛成绩</a></li>
      <li><a href="javascript:;" @click="linkTo(4)">我的团队</a></li>
    </ul>
    <div class="wrap">
        <vue-qr
            :text="qrInfo"
            :size="160"
            :margin="6"
            :callback="drawCanvas"
            qid="qrid"
            :bindElement="false"
        ></vue-qr>

        <img :src="qrcodeSrc" class="qrcode-img">

         <div class="bottom-tip">长按图片保存参赛证</div>
    </div>
    


  </div>
</template>

<script>
import VueQr from 'vue-qr'
import canvasBg from '../assets/certificate_bg.jpg'
import { getUserMatchCertInfo } from '@/api/index'
export default {
  name: 'certificate',
  components: { VueQr },
  data () {
    return {
      qrcodeSrc: '',
      qrInfo: '',
      infoObj:{
        enterDateTime:''
      },
      final: '',
      loading: null
    }
  },
  computed: {

  },
  created () {
    this.getDetail()
    this.loading = this.$createToast({
        time: 0,
        txt: ''
    })
    this.loading.show()
  },
  computed: {
    navShow: function() {
      return this.tab > 0 ? true : false;
    }
  },
  mounted() {
    
  },
  methods: {
    getAdvanceTime(endTime,minutes){
      let _this=this
      let result=""
      function add0(arg){
        let result2=''
        if(arg.toString().length==1){
          result2= '0'+arg
        }else{
          result2=arg
        }
        return result2
      }
      function getAdvanceItem(time){
        console.log(time)
        let timeArr=time.split(":")
        let hoursC=parseInt(timeArr[0]) 
        let minutesC=parseInt(timeArr[1]) 
        let totalMinutes= hoursC*60+minutesC
        let newHours=add0(parseInt((totalMinutes-minutes)/60 ) )  
        let newMinutes=add0((totalMinutes-minutes)%60)  
        return newHours+':'+newMinutes
      }
      let endTimeArr=endTime.split("-")
      result=result+getAdvanceItem(endTimeArr[0])+'-'
      result=result+endTimeArr[0]
      return result
    },
    getDetail(){
      let _this=this
      getUserMatchCertInfo().then((res) => {
      	if (res.errorCode == 200) {
          if(res.data.fianlCert == 'on') {
            _this.final = 'on';
            _this.qrInfo = window.location.origin + '/#/score?id=1&number=' + res.data.matchNumber
            _this.infoObj.name=res.data.name
            _this.infoObj.teamId=res.data.teamId
            _this.infoObj.matchNumber=res.data.matchNumber
            // _this.infoObj.examDateTime= res.data.fianlExamTime 
            // _this.infoObj.enterDateTime= res.data.finalEnterExamTime 
            // _this.infoObj.fianlExamAddress = res.data.fianlExamAddress
            _this.infoObj.examDateTime= '8月13日 9:30 ~ 8月18日 17:30';
            _this.infoObj.enterDateTime= '8月13日 9:00';
            _this.infoObj.fianlExamAddress = '葛家村智造园区3号楼6楼';
          } else {
            _this.qrInfo= window.location.origin + '/#/score?id=1&number=' + res.data.matchNumber
            _this.infoObj.name=res.data.name
            _this.infoObj.teamId=res.data.teamId
            _this.infoObj.matchNumber=res.data.matchNumber
            _this.infoObj.examDateTime=res.data.examDate+' '+res.data.examTime
            _this.infoObj.enterDateTime=res.data.examDate+ ' '+_this.getAdvanceTime(res.data.examTime,30)//自己计算，提前半小时
            _this.infoObj.fianlExamAddress = '浙江省服装产业创新服务综合体3号楼618室'
          }
          
      	} else {
      	}
      }).catch(err => {
      })
    },
    linkTo(index) {
      switch (index) {
        case 1:
          this.$router.push('/index')
          break;
        case 2:
          this.$router.push('/certificate')
          break;
        case 3:
          this.$router.push('/score')
          break;
        case 4:
          this.$router.push('/team')
      }
    },
    drawCanvas(qrdata, id) {
      console.log(qrdata, id)  
      var that = this
      var canvas = document.createElement('canvas')
      var context = canvas.getContext('2d')
      canvas.width = 672
      canvas.height = 908

      context.save()
      context.fillStyle = '#FFFFFF'
      context.fillRect(0, 0, canvas.width, canvas.height)
      context.restore()

      var image1 = new Image()
      image1.setAttribute("crossOrigin",'anonymous')
      image1.src = canvasBg
    
      image1.onload = function () {
        context.save()
        context.drawImage(image1, 0, 0, 672, 908)
        context.restore()
        var certTitle = '', cerAddress1 = '', cerAddress2 = '';
        if (that.final == 'on') {
          certTitle = '决 赛 参 赛 证';
        } else {
          certTitle = '预 赛 参 赛 证';
        }
        if (that.infoObj.fianlExamAddress) {
          cerAddress1 = that.infoObj.fianlExamAddress.substring(0, 14);
          cerAddress2 = that.infoObj.fianlExamAddress.substring(14);
        }

        context.save()
        context.fillStyle = '#fff'
        context.font = '40px sans-serif'
        context.textAlign = 'center'
        context.fillText(certTitle, 338, 62)
        context.restore()

        context.save()
        context.fillStyle = '#fff'
        context.font = '32px sans-serif'
        context.textAlign = 'left'
        context.fillText('姓       名', 30, 140)
        context.fillText('参赛编号', 30, 205)
        context.fillText('所在分组', 30, 270)
        context.fillText('入场时间', 30, 335)
        context.fillText('考试时间', 30, 400)
        context.fillText('参赛地点', 30, 465)
        context.restore()

        context.save()
        context.fillStyle = '#fff'
        context.font = '28px sans-serif'
        context.textAlign = 'left'
        context.fillText(that.infoObj.name, 220, 140)
        context.fillText(that.infoObj.matchNumber, 220, 205)
        context.fillText(that.infoObj.teamId+'组', 220, 270)
        context.fillText(that.infoObj.enterDateTime, 220, 335)
        context.fillText(that.infoObj.examDateTime, 220, 400)
        context.fillText(cerAddress1, 220, 465)
        context.fillText(cerAddress2, 220, 510)
        context.restore()

   

        var image2 = new Image()
        image2.src = qrdata

        image2.onload = function () {
          context.save()
          context.drawImage(image2, 260, 602, 160, 160)
          context.restore()
          that.qrcodeSrc = canvas.toDataURL('image/png')
          that.loading.hide()
        }
      }
    }
  }
}
</script>

<style scoped>
    #nav { z-index: 2; position: fixed; top: 0; opacity: 1; transition: 0.5s; width: 100%; padding: 0 0.3rem; max-width: 768px; height: 0.8rem; background: #fff; box-shadow: 0 0 10px #ccc; display: flex; justify-content: space-between;}
    #nav li {line-height: 0.8rem; text-align: center; }
    #nav li a { text-decoration: none; display: block; color: #333; font-size: 0.3rem;}
    #nav li.current a { color:#de7a31;   }
    #nav li i { width: 0.25rem; height: 0.27rem; display: inline-block; vertical-align: middle; margin-right: 2px; }
    #nav li.current i {background: url(../assets/icon_select.png) no-repeat; background-size: cover;}
    .wrap {padding: 1.36rem 0.3rem 0.3rem;}
    .qrcode-img {width: 100%;}
    .bottom-tip { font-size: 0.32rem; color: #666; padding: 0.4rem 0; text-align: center;}
</style>

